import Button from '../../Button'
import { Container } from '../Container'

import { INLINE_BUTTON_SIZES } from './Buttons.constants'

import * as styles from './Buttons.module.css'

import EditIcon from '../../../icons/edit.svg'
import PlusIcon from '../../../icons/plus.svg'

export function Text() {
  return (
    <>
      <Container label='Button, text, sizes - 24px, 16px'>
        {INLINE_BUTTON_SIZES.map(size => (
          <Button.Text
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, text, disabled, sizes - 24px, 16px'>
        {INLINE_BUTTON_SIZES.map(size => (
          <Button.Text
            disabled
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, text, with loader, sizes - 24px, 16px'>
        {INLINE_BUTTON_SIZES.map(size => (
          <Button.Text
            isLoading
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, text, with pre icon, sizes - 24px, 16px'>
        {INLINE_BUTTON_SIZES.map(size => (
          <Button.Text
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, text, with pre icon, with loader, sizes - 24px, 16px'>
        {INLINE_BUTTON_SIZES.map(size => (
          <Button.Text
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, text, with post icon, sizes - 24px, 16px'>
        {INLINE_BUTTON_SIZES.map(size => (
          <Button.Text
            afterIconProps={{ Icon: EditIcon }}
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, text, with post icon, with loader, sizes - 24px, 16px'>
        {INLINE_BUTTON_SIZES.map(size => (
          <Button.Text
            isLoading
            afterIconProps={{ Icon: EditIcon }}
            className={styles.margin}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='Button, text, icon, sizes - 24px, 16px'>
        {INLINE_BUTTON_SIZES.map(size => (
          <Button.Text
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='Button, text, icon, with loader, sizes - 24px, 16px'>
        {INLINE_BUTTON_SIZES.map(size => (
          <Button.Text
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            className={styles.margin}
            height={size}
            key={size}
          />
        ))}
      </Container>
    </>
  )
}
